<template>
  <div class="c-avatar">
    <img :src="src" class="c-avatar-img" alt="" />
    <img src="@/assets/images/avatar.png" class="c-avatar-grade" v-if="[6].some((val) => val === grade * 1)" />
    <img src="@/assets/images/avatar3.png" class="c-avatar-grade" v-if="[3, 4].some((val) => val === grade * 1)" />
    <img src="@/assets/images/avatar2.png" class="c-avatar-grade" v-if="[2, 5].some((val) => val === grade * 1)" />
  </div>
</template>
<script>
export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    grade: {
      type: String,
      default: '',
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {},
};
</script>
<style lang="scss" scoped>
.c-avatar {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  &-img {
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 50%;
  }
  &-grade {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 40%;
    height: auto;
  }
}
</style>
